import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import type {
  NoteValidityStatus,
  StockNoteCategory,
  UserStockNoteDTO,
  UserStockNotePanelResultDTO,
} from "./UserStockNoteType";
import { userStockNoteMocks } from "./UserStockNoteMock";

const mockUserStockNote = useLongfansMock && false;

const BASE = "/lark/app/userStockNote";

export const UserStockNoteApi = {
  async queryPanel(spaceId: string, stockCode: string): Promise<UserStockNotePanelResultDTO | null> {
    if (mockUserStockNote) {
      return userStockNoteMocks.queryPanel(stockCode);
    }
    const r = await post<{ spaceId: string; stockCode: string }, UserStockNotePanelResultDTO>(
      `${BASE}/queryPanel`,
      { spaceId, stockCode },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },

  async create(
    spaceId: string,
    param: {
      stockCode: string;
      stockName?: string;
      content: string;
      category: StockNoteCategory;
    }
  ): Promise<UserStockNoteDTO | null> {
    if (mockUserStockNote) {
      return userStockNoteMocks.create(
        param.stockCode,
        param.stockName ?? "",
        param.content,
        param.category
      );
    }
    const r = await post<typeof param & { spaceId: string }, UserStockNoteDTO>(
      `${BASE}/create`,
      { spaceId, ...param },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },

  async update(
    spaceId: string,
    param: {
      noteId: string;
      content: string;
      category: StockNoteCategory;
    }
  ): Promise<UserStockNoteDTO | null> {
    if (mockUserStockNote) {
      return userStockNoteMocks.update(param.noteId, param.content, param.category);
    }
    const r = await post<typeof param & { spaceId: string }, UserStockNoteDTO>(
      `${BASE}/update`,
      { spaceId, ...param },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },

  async delete(spaceId: string, noteId: string): Promise<boolean> {
    if (mockUserStockNote) {
      return userStockNoteMocks.delete(noteId);
    }
    const ok = await post(`${BASE}/delete`, { spaceId, noteId }, { silent: true });
    return typeof ok !== "string" && !!ok;
  },

  async markValidity(
    spaceId: string,
    param: {
      noteId: string;
      validityStatus: NoteValidityStatus;
    }
  ): Promise<UserStockNoteDTO | null> {
    if (mockUserStockNote) {
      return userStockNoteMocks.markValidity(param.noteId, param.validityStatus);
    }
    const r = await post<typeof param & { spaceId: string }, UserStockNoteDTO>(
      `${BASE}/markValidity`,
      { spaceId, ...param },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },
};
